import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import CustomCursor from "@/components/CustomCursor";

export default function CheckEmail() {
    const navigate = useNavigate();
    return (
        <div style={{
            minHeight: "100vh",
            background: "linear-gradient(180deg, #07091f 0%, #0c1235 25%, #111840 50%, #1e1245 70%, #2a1550 100%)",
            display: "flex", alignItems: "center", justifyContent: "center",
        }}>
            <CustomCursor />
            <motion.div
                initial={{ opacity: 0, scale: 0.93 }}
                animate={{ opacity: 1, scale: 1 }}
                style={{
                    background: "rgba(255,255,255,0.07)",
                    backdropFilter: "blur(32px)",
                    border: "1px solid rgba(255,255,255,0.16)",
                    borderRadius: 16,
                    padding: "40px 36px",
                    textAlign: "center",
                    maxWidth: 400,
                    width: "100%",
                    margin: "0 16px",
                }}
            >
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 180 }}
                    style={{
                        width: 64, height: 64, borderRadius: "50%",
                        background: "rgba(124,58,237,0.15)",
                        border: "1px solid rgba(124,58,237,0.4)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        margin: "0 auto 20px",
                    }}
                >
                    <Mail style={{ color: "#7c3aed", width: 28, height: 28 }} />
                </motion.div>
                <h2 style={{ color: "white", fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: 22, marginBottom: 10 }}>
                    Check your inbox
                </h2>
                <p style={{ color: "rgba(255,255,255,0.5)", fontFamily: "'DM Sans',sans-serif", fontSize: 14, lineHeight: 1.6, marginBottom: 28 }}>
                    We sent a verification link to your email address. Click the link to activate your account.
                </p>
                <button
                    onClick={() => navigate("/auth")}
                    style={{
                        width: "100%", padding: "12px",
                        background: "rgba(124,58,237,0.8)",
                        border: "1px solid rgba(124,58,237,0.5)",
                        borderRadius: 9, color: "white",
                        fontFamily: "'DM Sans',sans-serif",
                        fontWeight: 600, cursor: "pointer", fontSize: 15,
                    }}
                >
                    Back to login
                </button>
            </motion.div>
        </div>
    );
}
